import { PanelResult } from "common/panel/dto/PanelResult";
import SearchResultList, {
  PageNavigation,
} from "components/common/SearchResultList";
import PanelItem from "./PanelItem";
import { useSakusasPanelSearch } from "hooks/sakusas/panel/useSakusasPanelSearch";
import { PANEL_PER_PAGE_MAX } from "constant/panel";
import { useEffect, useState } from "react";
import { PanelSearchParams } from "common/api/sakusas/sakusas_panel";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { QUERY_KEYS } from "constant/react_query";
import { panelSearchFieldsGet } from "common/panel/panel_search";
import PanelSearchFilters from "components/common/panel/PanelSearchFilters";
import { SEARCH_NAMES } from "constant/search";

const PanelList = () => {
  const [searchParams, setSearchParams] = useState<PanelSearchParams>({
    [SEARCH_NAMES.LIMIT]: PANEL_PER_PAGE_MAX,
    [SEARCH_NAMES.SKIP]: 0,
  });
  const panelListResult = useSakusasPanelSearch(searchParams);
  const invalidateQuery = useInvalidateQueryByKeys();
  useEffect(() => {
    invalidateQuery.invalidateQueriesByKeys([QUERY_KEYS.SAKUSAS_VIDEO_SEARCH]);
  }, [searchParams]);

  let results: PanelResult[] = panelListResult ? panelListResult["items"] : [];
  const resTotal: number = panelListResult ? panelListResult["resTotal"] : 0;
  const pageNavigationHandle = (pageNum: number) => {
    const skip = pageNum * PANEL_PER_PAGE_MAX;
    setSearchParams({ ...searchParams, skip });
  };
  const pageNavigation: PageNavigation = {
    resTotal,
    limit: PANEL_PER_PAGE_MAX,
    skip: searchParams.skip ?? 0,
    pageNavigationHandle,
  };

  const searchHandle = (formData: any) => {
    const searchVals = panelSearchFieldsGet(formData);

    setSearchParams({
      ...searchParams,
      ...searchVals,
      skip: 0,
    });
  };

  return (
    <div>
      <PanelSearchFilters searchHandle={searchHandle} />
      <SearchResultList<PanelResult>
        renderSingle={(panel: PanelResult) => (
          <PanelItem panel={panel} key={`panel${panel.id}`} />
        )}
        results={results}
        pageNavigation={pageNavigation}
      />
    </div>
  );
};

export default PanelList;
